let resumeData = {
  imagebaseurl: "https://sunnyeureka.github.io/",
  name: "Sunny Dey",
  role: "Frontend Developer & a Javascript Nerd",
  linkedinId: "https://www.linkedin.com/in/sunny-dey-00977a1ba/",
  skypeid: "Your skypeid",
  roleDescription: " I can create some awesome websites for you!",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/sunny-dey-00977a1ba/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/sunnyeureka",
      className: "fa fa-github",
    },
    {
      name: "skype",
      url: "",
      className: "fa fa-twitter",
    },
  ],
  aboutme:
    "I like dabbling in various parts of frontend development and like to learn about new technologies or simply play games in my free time. I am currently employed in an organisation working as a Software Engineer for ReactJs",
  address: "India",
  website: "https://sunnyeureka.github.io/portfolio/",

  education: [
    {
      UniversityName: "Brainware Group of Institutions",
      specialization: "Computer Science & Engineering",
      MonthOfPassing: "June",
      YearOfPassing: "2019",
      Achievements: "",
    },
  ],
  work: [
    {
      CompanyName: "Tata Consultancy Services",
      specialization: "Angular Developer",
      MonthOfLeaving: "May",
      YearOfLeaving: "2021",
      Achievements: "",
    },
    {
      CompanyName: "Newgen Software Pvt Ltd.",
      specialization: "ReactJs Developer",
      MonthOfLeaving: "Presently working",
      YearOfLeaving: "",
      Achievements: "",
    },
  ],
  skillsDescription: "HTML5, CSS, Angular, ReactJs, Next.Js",
  skills: [
    {
      skillname: "HTML5",
    },
    {
      skillname: "CSS",
    },
    {
      skillname: "Reactjs",
    },
    {
      skillname: "Angular",
    },
    {
      skillname: "Next.Js",
    },
  ],
  portfolio: [
    {
      name: "Worldwide Covid-19 Tracker",
      description: "Web App",
      imgurl: "images/portfolio/phone.JPG",
      link: "https://covid-19-tracker-3f3b7.web.app/",
    },
  ],
  testimonials: [],
};

export default resumeData;
